import { Flex, Radio } from 'antd';
import styles from './planSelectionItem.module.css';

export default function PlanSelectionItem(props) {
   const { plan, checked, onClick } = props;

   return (
      <Flex
         gap={16}
         key={plan._id}
         onClick={onClick}
         className={[styles.plan, checked ? styles.selectedPlan : ''].join(' ')}
      >
         <Flex gap={16} align="center" style={{ width: '100%' }}>
            <Radio checked={checked} onChange={onClick} value={plan._id} name="radio-buttons" />
            <p>{plan.name}</p>
         </Flex>
         <Flex vertical gap={16} align="flex-end" style={{ width: '100%' }}>
            <p>$ {plan.billingType == 'yearly' ? (plan.price / 12).toPrecision(2) : plan.price} / month</p>
         </Flex>
      </Flex>
   );
}
